/**
 * joy space 分享文档组件
 * @author sunzhiguang
 * @date 2020/6/10
 */
import React, { useEffect } from "react";
import "./index.less";
import { MessageStatus } from "@/types/chat";
import { MessageSendType } from "@/types/chat/enum";
import { WithTranslation, withTranslation } from "react-i18next";
import { changeEgovUrl } from "@/utils/tools";
import DeeplinkEvent from "@/components/DeeplinkHandler/DeeplinkEvent";
import { FocusSDK, isFocusEnv } from "@/utils";
import { message as toast } from "antd";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import { genThirdAppUrl } from "@/components/ThirdApp";
import { getAppVersion } from "@/utils/getVersion";

interface OptionItem {
  type: string;
  name: string;
  pcUrl?: string;
  mobileUrl?: string;
}

interface DefaultCommonCardProps {
  message: any;
  sendType: MessageSendType;
  onReady: (params: { beginSend: boolean; messageExtend: any }) => {};
}

type IProps = Readonly<DefaultCommonCardProps & WithTranslation>;

function DefaultCommonCard(props: IProps) {
  const { authInfo, appRuntimeEnv } = React.useContext<GlobalContextConfig>(GlobalContext);
  const { sendType, message, onReady } = props;
  const { common_card = {} } = message.data[0] || {};
  const optionList: OptionItem[] = common_card.optionList || [];
  const renderOptionList = optionList.slice(0, 2);
  const supportOptionList = ["link"];
  const version = getAppVersion(FocusSDK);

  const handleClick = (isBtnOperate?: boolean, btnOption?: any) => {
    const data = isBtnOperate ? btnOption : common_card;
    if (!data.pcUrl) {
      return;
    }
    const parseUrl = DeeplinkEvent.parseDeeplink(data.pcUrl);
    if (!parseUrl) {
      toast.warn("当前跳转链接不符合规范");
      return;
    }
    const isPrivateNet = FocusSDK.isPrivateNet();
    const mparam = parseUrl.mparam || {};
    if (isFocusEnv() && version < (mparam.minVersion || "1.0.0")) {
      toast.warn("当前版本暂不支持，请升级至最新版本");
      return;
    }
    let realUrl = isPrivateNet ? mparam.egovUrl : mparam.url;
    if (!realUrl) {
      toast.warn("该应用不支持在当前网络环境下打开");
      return;
    }
    realUrl = genThirdAppUrl(
      common_card.applicationKey,
      authInfo.ddAppId,
      authInfo.accessToken,
      appRuntimeEnv,
      {
        redirectUrl: realUrl
      }
    );
    console.log(`${isBtnOperate ? "点击操作区域链接" : "点击热区"}`, realUrl);
    window.open(realUrl);
  };

  const handleClickOption = (event: any, option: OptionItem) => {
    event.preventDefault();
    event.stopPropagation();
    if (!supportOptionList.includes(option.type)) {
      toast.warn("当前版本暂不支持，请升级至最新版本");
    }
    if (option.type === "link") {
      handleClick(true, option);
    }
  };

  useEffect(() => {
    if (sendType === MessageSendType.OWNER && message.status === MessageStatus.INIT) {
      onReady({ beginSend: true, messageExtend: {} });
    }
  }, [sendType, message, onReady]);

  return (
    <div className="default-msg-commom-card" onClick={() => handleClick()}>
      <div className="default-msg-commom-card_name ellipsis">{common_card.applicationName}</div>
      <div className="default-msg-commom-card_info">
        <div className="info_left">
          <div className="info_left_title overflow_line2">{common_card.title}</div>
          <div className="info_left_content overflow_line2">{common_card.content}</div>
        </div>
        <div className="info_icon">
          <img src={changeEgovUrl(common_card.icon)} />
        </div>
      </div>
      <div className="default-msg-commom-card_btns">
        {(renderOptionList || []).length <= 1 && (
          <div className="btns_tip ellipsis">{common_card.tips}</div>
        )}
        <div className="btns_item">
          {(renderOptionList || []).map((option, index) => {
            return (
              <div
                className="ellipsis"
                key={index}
                onClick={(event) => handleClickOption(event, option)}
              >
                {option.name}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default withTranslation("chat")(DefaultCommonCard);
